// Generated by scripts/build-ui-icons.mjs.
export { Plant as default } from "../ui/glyphs-6";
